<template>
  <c-modal-form
    :id="$getConst('PRIVILEGE_ORDER_MODAL_ID')"
    :loading="loading"
    :submit-btn-enabled="canSubmit"
    submit-btn-text="Заказать"
    :error="error"
    fields-required
    title="Заказать привилегию"
    @submit="submit()"
  >
    <form>
      <c-date-picker
        v-if="symbolName === 'birth'"
        v-model="birthDate"
        title="*День рождения компании:"
        help-text="Формат DD-MM-YYYY, например 05-03-2010"
        form-group
      />
      <c-input
        v-else
        v-model="birthDate"
        form-group
      />
    </form>
    <demo-denied />
  </c-modal-form>
</template>

<script>
import CModalForm from '../../../../../../../resources/js/components/ui/CModalForm'
import CInput from '../../../../../../../resources/js/components/ui/CInput'
import form from '../../../../../../../resources/js/mixins/form'
import modal from '../../../../../../../resources/js/mixins/modal'
import apiService from '../../apiService'
import CDatePicker from '../../../../../../../resources/js/components/ui/CDatePicker'
import { mapActions, mapGetters, mapState } from 'vuex'
import Notification from '../../../../../../../resources/js/notification'
import DemoDenied from '../DemoDenied'

/**
 * Модальное окно "Заказать привилегию".
 */
export default {
  name: 'PrivilegeOrder',
  components: {
    DemoDenied,
    CModalForm,
    CInput,
    CDatePicker
  },
  mixins: [form, modal],
  data: () => {
    return {
      birthDate: ''
    }
  },
  computed: {
    /**
     * Происходит ли загрузка или отправка данных.
     *
     * @returns {boolean}
     */
    loading () {
      return !!(this.clientDomainsFetching || this.sending)
    },
    /**
     * Может ли форма быть отправлена.
     *
     * @returns {boolean}
     */
    canSubmit () {
      return !!(this.domainSelected && this.birthDate && !this.isDemo)
    },
    ...mapState({
      domainSelected: state => state.seo.client.domains.selected,
      symbolName: state => state.seo.forms.loyaltyProgram.symbolName,
      clientDomainsFetching: state => state.seo.client.domains.fetching
    }),
    ...mapGetters({
      isDemo: 'seo/client/info/isDemo'
    })
  },
  mounted () {
    $(`#${this.$getConst('PRIVILEGE_ORDER_MODAL_ID')}`).on('hidden.bs.modal', () => {
      this.resetState()
    })
  },
  methods: {
    /**
     * Сбрасывает данные формы.
     */
    resetState () {
      this.birthDate = ''
    },
    /**
     * Отправляет данные формы.
     */
    submit () {
      this.sending = true
      this.error = false

      apiService.postFormsLoyaltyProgram(this.domainSelected, this.symbolName, this.birthDate)
        .then(() => {
          this.connectPrivilege(this.symbolName)
          this.hideModal(this.$getConst('PRIVILEGE_ORDER_MODAL_ID'))
          this.resetState()

          this.sending = false

          Notification.notifySuccess({
            title: 'Данные отправлены'
          })
        })
        .catch(() => {
          this.sending = false

          this.error = true
        })
    },
    ...mapActions({
      connectPrivilege: 'seo/forms/loyaltyProgramMap/connectPrivilege'
    })
  }
}
</script>
